<div class="modal-body-parent">
  <div class="status-buttons text-center">
    <a *ngFor="let step of steps; let i = index" [ngClass]="{'active': currentStep === i}">
    <span>{{i + 1}}</span>
    <div>{{step.title}}</div></a>
  </div>
  <div class="modal-body">
    <ng-template *hubDynamicComponent></ng-template>
  </div>
</div>